import { render, staticRenderFns } from "./MainAreaFooter.vue?vue&type=template&id=a555427e&scoped=true&"
import script from "./MainAreaFooter.vue?vue&type=script&lang=js&"
export * from "./MainAreaFooter.vue?vue&type=script&lang=js&"
import style0 from "./MainAreaFooter.vue?vue&type=style&index=0&id=a555427e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a555427e",
  null
  
)

export default component.exports